import { Customer } from 'server/shared/models/customer';
import { Employment } from 'server/shared/models/employment';
import { EmploymentInvitee } from 'server/shared/models/employmentInvitee';
import { PoolerUser } from 'server/shared/models/user';
import { PoolerCustomerMap } from 'server/shared/helpers/PoolerMap';
import { PreparedEmploymentInvitee } from '../../types/employment/PreparedEmploymentInvitee';
import { getEmploymentCustomerTariff } from '../getCustomerTariff';
import {
  getAvailabilityMatchPercentage,
  getAvailabilityMatchPercentageRange,
} from './getAvailabilityMatchPercentage';

export function prepareEmploymentInvitee(
  invitee: EmploymentInvitee,
  usersById: Map<string, PoolerUser>,
  employment: Employment,
  currentCustomer: Customer,
  poolerMap: PoolerCustomerMap,
): PreparedEmploymentInvitee {
  const user = usersById.get(invitee.userId || '');
  const preparedInvitee: PreparedEmploymentInvitee = {
    ...invitee,
    user,
    matchPercentage: getAvailabilityMatchPercentage(
      user?.employmentAvailabilityDays ||
        invitee.personalData.externalAvailabilityDays ||
        [],
      getAvailabilityMatchPercentageRange(
        employment.startDate,
        employment.endDate,
      ),
      employment.workload,
      employment._id,
    ),
  };
  if (user) {
    const customerOfUser = poolerMap.getCustomerOfUser(user._id);
    if (customerOfUser && customerOfUser?._id !== currentCustomer._id) {
      preparedInvitee.originCustomer = {
        id: customerOfUser._id,
        displayName: customerOfUser.name,
        tariff: getEmploymentCustomerTariff(
          currentCustomer,
          customerOfUser._id,
          user.certificates || [],
        ),
      };
    } else if (invitee.customer.id !== currentCustomer._id) {
      preparedInvitee.originCustomer = {
        id: invitee.customer.id,
        displayName: invitee.customer.displayName,
        tariff: getEmploymentCustomerTariff(
          currentCustomer,
          invitee.customer.id,
          invitee.personalData?.certificates || [],
        ),
      };
    }
  } else if (invitee.customer.id !== currentCustomer._id) {
    preparedInvitee.originCustomer = {
      id: invitee.customer.id,
      displayName: invitee.customer.displayName,
      tariff: getEmploymentCustomerTariff(
        currentCustomer,
        invitee.customer.id,
        invitee.personalData?.certificates || [],
      ),
    };
  }
  return preparedInvitee;
}
